import makeStyles from '@mui/styles/makeStyles';
import { theme } from 'theme/App.theme';

export const useStyles = makeStyles({
  modal_header: {
    width: '100%',
    minHeight: '2rem',
    height: 'auto',
    margin: '0',
    padding: '1rem 1rem',
  },
  modal_header_title: {
    margin: 0,
  },
  close_button: {
    display: 'flex',
    position: 'absolute',
    border: 0,
    padding: 0,
    backgroundColor: 'transparent',
    '& svg': {
      borderRadius: '5rem',
      transition: 'all 0.4s ease-in-out',
      boxSizing: 'border-box',
    },
    '&:hover svg': {
      cursor: 'pointer',
      transform: 'rotate(90deg)',
    },
  },
  regular_style: {
    right: '1rem',
    top: '1rem',
    '& svg': {
      width: '1.75rem',
      height: '1.75rem',
      [theme.breakpoints.up('viewportMedium')]: {
        width: '2rem',
        height: '2rem',
      },
    },
  },
  non_react_style: {
    right: '0.625rem',
    top: '0.625rem',
    [theme.breakpoints.up('viewportMedium')]: {
      right: '1.8125rem',
      top: '1.125rem',
    },
    '& svg': {
      width: '1.875rem',
      height: '1.875rem',
      [theme.breakpoints.up('viewportXLarge')]: {
        width: '2.5rem',
        height: '2.5rem',
      },
    },
  },
  video_style: {
    right: '0.78125rem',
    top: '-2.5rem',
    [theme.breakpoints.up('viewportMediumMid')]: {
      top: '0',
      right: '3.75rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      top: '-2.5rem',
      right: '1.875rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      right: '10.625rem',
    },
    '& svg': {
      width: '1.875rem',
      height: '1.875rem',
    },
  },
  data_header: {
    display: 'flex',
    marginBottom: '1rem',
  },
  custom_image: {
    position: 'relative',
  },
  title_image: {
    minHeight: '1.5rem',
    width: 'auto',
    height: '3.75rem',
    maxWidth: '3.75rem',
    maxHeight: '3.75rem',
    margin: 'auto 1rem auto 0',
  },
  modal_text: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    margin: 0,
  },
});
